const GENERIC_TITLES = new Set([
  "Details", "Client", "DigiFist", "Documentation", "Documentations",
  "Themes", "Apps", "Blog", "FAQs",
]);

function plainText(value) {
  // CMS metadata and Title are plain text. Do not flatten rich-text bodies or
  // stringify relation objects into search snippets.
  return typeof value === "string" && value.trim() && !/[<>]/.test(value)
    ? value.trim()
    : undefined;
}

function layoutMetadata({ current, data, title, description } = {}) {
  // current is the article on help pages; data there may describe its parent.
  const attributes = current?.attributes || data?.attributes || data?.data?.attributes;
  const seo = attributes?.SEO;
  const explicitTitle = plainText(seo?.Title) || plainText(seo?.MetaTitle);
  const contentTitle = plainText(attributes?.Title);
  const fallbackTitle = GENERIC_TITLES.has(title) && contentTitle
    ? /digifist/i.test(contentTitle) ? contentTitle : `${contentTitle} | DigiFist`
    : title;

  return {
    title: explicitTitle || fallbackTitle,
    description: plainText(seo?.MetaDescription) || description,
  };
}

module.exports = { layoutMetadata };
